import { useQuery } from '@tanstack/react-query';
import { fetchOrgModuleAccess } from '../request/membership/moduleAccess.api.ts';

function getStoredOrganizationId(): string {
  if (typeof window === 'undefined') return '';
  return window.localStorage.getItem('organization_id') ?? '';
}

export function useOrgModuleAccess() {
  const organizationId = getStoredOrganizationId();
  return useQuery({
    queryKey: ['org-membership', 'module-access', organizationId],
    queryFn: fetchOrgModuleAccess,
    enabled: Boolean(organizationId),
    staleTime: 60_000,
  });
}
